import React from 'react';

interface QRDisplayProps {
  qrData: string;
}

const QRDisplay: React.FC<QRDisplayProps> = ({ qrData }) => {
  return (
    <div className="p-4 bg-white rounded-lg shadow">
      <img 
        src={`data:image/png;base64,${qrData}`} 
        alt="Payment QR Code" 
        className="w-64 h-64"
      />
    </div>
  );
};

export default QRDisplay;